module.exports = __webpack_public_path__ + "img/04.078d5634.jpg";